/* global projectContext */
const React = require("react");
const _ = require('underscore');
const createReactClass = require("create-react-class");

const UserTable = require('./user_table.jsx');
const InviteForm = require('./invite_form.jsx');
const InviteFormMessage = require('./form_message.jsx');
const SecuritySettings = require('./mfa/SecuritySettingsModal.jsx');
const AccountResetModal = require('./mfa/AccountResetModal.jsx');

const TeamPage = createReactClass({

	getInitialState: function() {
		return {
			SecurityID: this.props.model.InitialSecurityID,
			message: {
				className: '',
				text: ''
			},
			members: this.props.model.InitialMembers,
			invites: this.props.model.InitialInvites,
			security: this.props.model.MFA,
			showSecurity: false,
			resetAccount: false,
		};
	},

	handleSecuritySettings: function() {
		this.setState({
			showSecurity: !this.state.showSecurity
		});
	},

	resetAccount: function(id) {
		this.setState({
			resetAccount: id
		});
	},

	handleInvite: function(email, role) {
		this.setState({
			message: {
				className: 'alert alert-info',
				text: 'Loading...'
			}
		});

		var invitation = {
			Email: email.value.trim(),
			GroupID: role.options[role.selectedIndex].value
		};
		invitation.DispatcherSecurityID = this.state.SecurityID;

		var className = "";
		$.ajax({
			url: projectContext.inviteForm.action,
			dataType: 'json',
			cache: false,
			type: 'POST',
			data: invitation,
			success: function(data) {
				if(data.message.type === 'bad') {
					className = 'alert-error';
				} else {
					className = 'alert-success';
					if (email.hasOwnProperty('form')) {
						email.form.reset();
					}
				}

				this.setState({
					status: 'ready',
					message: {
						className: 'alert ' + className,
						text: data.message.text
					},
					SecurityID: data.NewSecurityID,
					members: data.members,
					invites: data.invites
				});
			}.bind(this),
			error: function(xhr) {
				this.setState({
					status: 'ready',
					message: {
						className: 'alert alert-error',
						text: this.errorMessageFromJQueryXhr(xhr),
					}
				});
			}.bind(this)
		});
	},

	resendInvite: function(requestData) {
		var email = {
			value: requestData.Email
		}
		var role = {
			options: [{value: requestData.GroupID}],
			selectedIndex: 0
		}

		this.handleInvite(email, role)
	},

	ejectMember: function(requestData) {
		this.setState({
			message: {
				className: 'alert alert-info',
				text: 'Loading...'
			}
		});

		// Set the security ID
		requestData.DispatcherSecurityID = this.state.SecurityID;

		$.ajax({
			url: projectContext.ejectMember,
			dataType: 'json',
			cache: false,
			type: 'POST',
			data: requestData,
			success: function(data) {
				if (data.redirect) {
					window.location.href = data.redirect;
					return;
				}

				this.setState({
					SecurityID: data.NewSecurityID,
					members: data.members,
					message: {
						className: 'alert alert-success',
						text: 'User removed from stack.'
					}
				});
			}.bind(this),
			error: function(xhr) {
				this.setState({
					message: {
						className: 'alert alert-error',
						text: this.errorMessageFromJQueryXhr(xhr),
					}
				});
			}.bind(this)
		});
	},

	cancelInvite: function(requestedData) {
		this.setState({
			message: {
				className: '',
				text: ''
			}
		});

		requestedData.DispatcherSecurityID = this.state.SecurityID;

		$.ajax({
			url: projectContext.cancelInvite,
			dataType: 'json',
			cache: false,
			type: 'POST',
			data: requestedData,
			success: function(data) {
				this.setState({
					SecurityID: data.NewSecurityID,
					invites: data.invites,
					message: {
						className: 'alert alert-success',
						text: data.message
					}
				});
			}.bind(this),
			error: function(xhr) {
				this.setState({
					message: {
						className: 'alert alert-error',
						text: this.errorMessageFromJQueryXhr(xhr),
					}
				});
			}.bind(this)
		});
	},

	changeRole: function(requestData) {
		this.setState({
			message: {
				className: 'alert alert-info',
				text: 'Loading...'
			}
		});

		// Set the security ID
		requestData.DispatcherSecurityID = this.state.SecurityID;

		$.ajax({
			url: projectContext.changeRole,
			dataType: 'json',
			cache: false,
			type: 'POST',
			data: requestData,
			success: function(data) {
				this.setState({
					SecurityID: data.NewSecurityID,
					members: data.members,
					message: {
						className: 'alert alert-success',
						text: data.message
					}
				});
			}.bind(this),
			error: function(xhr) {
				this.setState({
					message: {
						className: 'alert alert-error',
						text: this.errorMessageFromJQueryXhr(xhr),
					}
				});
			}.bind(this)
		});
	},

	errorMessageFromJQueryXhr(xhr) {
		let message = xhr.responseText;
		if (_.has(xhr.responseJSON, 'errors')) {
			message = _.map(xhr.responseJSON.errors, (error) => error.title).join(' ');
		}
		return message;
	},

	updateSecurity(data) {
		let newState = {
			showSecurity: false
		};

		if (data) {
			newState['security'] = data.data.MFA;
			newState['message'] = {
				className: 'alert alert-success',
				text: data.message
			};
		}

		this.setState(newState);
	},

	updateResetAccount(data) {
		let newState = {
			resetAccount: false
		};

		if (data) {
			newState['security'] = data.data.MFA;
			newState['message'] = {
				className: 'alert alert-success',
				text: data.message
			};
		}

		this.setState(newState);
	},

	render: function() {
		let securityModal = null;
		if (this.state.showSecurity) {
			securityModal = (
				<SecuritySettings
					model={this.state.security}
					securityID={this.state.SecurityID}
					closeHandler={this.updateSecurity}
				/>
			);
		}

		let resetModal = null;
		if (this.state.resetAccount) {
			resetModal = (
				<AccountResetModal
					model={this.state.security}
					securityID={this.state.SecurityID}
					closeHandler={this.updateResetAccount}
					user={this.state.resetAccount}
				/>
			);
		}

		return (
			<div>
				<InviteFormMessage message={this.state.message} />
				<InviteForm
					model={this.props.model}
					context={projectContext}
					handleInvite={this.handleInvite}
					handleSecuritySettings={this.handleSecuritySettings}
				/>
				<UserTable
					model={this.props.model}
					members={this.state.members}
					invites={this.state.invites}
					ejectMember={this.ejectMember}
					resendInvite ={this.resendInvite}
					cancelInvite={this.cancelInvite}
					changeRole={this.changeRole}
					resetAccount={this.resetAccount}
				/>
				{securityModal}
				{resetModal}
			</div>
		);
	}
});


module.exports = TeamPage;
